import { Tag, Badge } from 'antd'
import React from 'react'

// Use a fixed reference date to ensure consistent display (April 2, 2025, 09:30:00)
const CURRENT_REFERENCE_DATE = new Date('2025-04-02T09:30:00')

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const options = {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }
  return new Date(dateTimeString).toLocaleString(undefined, options)
}

// Calculate and format elapsed time using fixed reference date
export const getElapsedTime = (startTimeString) => {
  if (!startTimeString) return ''

  const startTime = new Date(startTimeString)
  const now = CURRENT_REFERENCE_DATE // Use the fixed reference date

  const elapsedMs = now - startTime
  if (elapsedMs < 0) return '0m elapsed'

  const elapsedMinutes = Math.floor(elapsedMs / (1000 * 60))
  const hours = Math.floor(elapsedMinutes / 60)
  const minutes = elapsedMinutes % 60

  return `${hours}h ${minutes}m elapsed`
}

// Calculate and format remaining time using fixed reference date
export const getRemainingTime = (endTimeString) => {
  if (!endTimeString) return ''

  const endTime = new Date(endTimeString)
  const now = CURRENT_REFERENCE_DATE // Use the fixed reference date

  const remainingMs = endTime - now
  if (remainingMs < 0) return '0m remaining'

  const remainingMinutes = Math.floor(remainingMs / (1000 * 60))
  const hours = Math.floor(remainingMinutes / 60)
  const minutes = remainingMinutes % 60

  return `${hours}h ${minutes}m remaining`
}

// Helper function to calculate procedure progress percentage with fixed reference date
export const calculateProgressPercent = (startTime, endTime) => {
  const start = new Date(startTime).getTime()
  const end = new Date(endTime).getTime()
  const now = CURRENT_REFERENCE_DATE.getTime() // Use fixed reference date

  if (now < start) return 0
  if (now > end) return 100

  const total = end - start
  const elapsed = now - start
  return Math.round((elapsed / total) * 100)
}

export const getPriorityTag = (priority) => {
  let color = 'blue'
  if (priority === 'High') color = 'orange'
  if (priority === 'Critical') color = 'red'
  if (priority === 'Low') color = 'green'

  return <Tag color={color}>{priority}</Tag>
}

export const getStatusBadge = (status) => {
  switch (status) {
    case 'Active':
    case 'In Progress':
      return <Badge status='processing' text={status} />
    case 'Pending':
    case 'Scheduled':
      return <Badge status='warning' text={status} />
    case 'Completed':
    case 'Discharged':
      return <Badge status='success' text={status} />
    case 'Cancelled':
      return <Badge status='error' text={status} />
    default:
      return <Badge status='default' text={status} />
  }
}

export const getUrgencyTag = (urgency) => {
  let color = 'blue'
  if (urgency === 'Emergency') color = 'red'
  if (urgency === 'Urgent') color = 'orange'
  if (urgency === 'Elective') color = 'green'

  return <Tag color={color}>{urgency}</Tag>
}

export const getTheatreStatusBadge = (status) => {
  switch (status) {
    case 'Active':
      return <Badge status='processing' text={status} />
    case 'Setup':
      return <Badge status='warning' text={status} />
    case 'Cleaning':
      return <Badge status='default' text={status} />
    case 'Maintenance':
      return <Badge status='error' text={status} />
    default:
      return <Badge status='default' text={status} />
  }
}
